<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain">
      <el-row style="padding-bottom: 20px">
        <el-col :span="24">
          <el-button type="primary" @click="add()">新增用户</el-button>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="userId" label="主键" align="center"> </el-table-column>
            <el-table-column prop="loginName" label="账号"></el-table-column>
            <el-table-column prop="userName" label="真名"></el-table-column>
            <el-table-column prop="createTime" label="申请时间"></el-table-column>

            <el-table-column prop="mobile" label="绑定手机号"></el-table-column>

            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="loginTime" label="最近登录时间"></el-table-column>

            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button size="small" @click="delRow(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize" :current-page="currentPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <UserAdd ref="UserAdd" @submitSuccess="submitSuccess"></UserAdd>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import UserAdd from "@/components/UserAdd.vue"
import usersApi from "@/api/users"

export default {
  components: { PageHeader, UserAdd },
  data() {
    return {
      headLinks: [
        { path: "", title: "基础数据" },
        { path: "", title: "用户管理" },
      ],
      tableData: [],
      words: "",
      total: 0,
      pagesize: 10,
      currentPage: 1,
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    add() {
      this.$refs.UserAdd.open()
    },
    loadData() {
      usersApi.getListForPage(this.words, "userId", "DESC", this.currentPage, this.pagesize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    pageChange(curPage) {
      this.currentPage = curPage
      this.loadData()
    },

    delRow(row) {
      this.$confirm("确定删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        usersApi.deletes(row.userId).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
            })
            this.loadData()
          } else {
            this.$notify.error({
              title: "错误",
              message: "删除失败" + res.msg,
            })
          }
        })
      })
    },

    submitSuccess() {
      this.loadData()
    },
  },
}
</script>

<style scoped>
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
